import React from "react";
import MeetTeamCarousel from "./carousel/Carousel";
import { Link } from "react-router-dom";

interface IMeetTeamProps {
  title: string;
  description: string;
  teamMembers: ITeamMember[];
  leftMember: any;
  hideDescription?: boolean;
  className?: string;
}

export interface ITeamMember {
  name: string;
  role: string;
  description: string;
  facebook: string;
  instagram: string;
  twitter: string;
  image: string;
}

const MeetTeam: React.FC<IMeetTeamProps> = ({
  title,
  description,
  teamMembers,
  leftMember,
  hideDescription,
  className,
}) => {
  return (
    <div>
      <div className="flex flex-col justify-center items-center w-full">
        <p className="text-xs xl:text-base">OUR TEAM</p>
        <h3
          className={`text-center xl:pt-4 text-2xl md:text-3xl lg:text-4xl xl:text-6xl font-medium ${className ? "max-w-4xl" : "max-w-2xl"}`}
        >
          {title}
        </h3>
        {/* <p className="font-light text-xs xl:pt-4 text-center pt-2 sm:text-sm text-[#5F6980] max-w-xs  sm:max-w-3xl xl:text-lg">
          {description}
        </p> */}
      </div>
      <div className="flex flex-col lg:flex-row my-10 gap-10 pt-5 ">
        <div className="flex justify-center items-center flex-1">
          <div className="w-full flex justify-center items-center lg:pb-12">
            <div className="flex flex-col w-full max-w-[45rem] border">
              <div className="h-56 lg:h-64 overflow-hidden flex justify-center items-center">
                <img
                  src={leftMember.image}
                  alt=""
                  className="w-fit h-full object-cover object-center"
                />
              </div>

              <div className="space-y-1 p-2">
                <h4 className="font-medium">{leftMember.name}</h4>
                <h5 className="font-light text-sm">{leftMember.role}</h5>
                {/* <p className="text-[#5F6980] text-xs">
                  {leftMember.description}
                </p> */}
                <div className="flex gap-3 pt-3">
                  <Link to={leftMember.linkedin} target="_blank">
                    <img src="/company/linkedin.svg" alt="" className="w-6" />
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="flex flex-1 justify-center w-full ">
          <MeetTeamCarousel
            slides={teamMembers}
            hideDescription={hideDescription}
          />
        </div>
      </div>
    </div>
  );
};

export default MeetTeam;
